import EditorState from "../data/state/EditorState";

function EditorReducer(state, action) {

    switch (action.type) {
        case 'addSelectedBlock': {
            return {
                ...state,
                blocksSelected : [...state.blocksSelected, action.payload.block]
            };
        }

        case 'setSelectedBlocks': {
            return {
                ...state,
                blocksSelected : action.payload.blocks
            };
        }

        case 'createTmpPath' : {

            return {
                ...state,
                pathTmp : { 
                     x : action.payload.x,
                     y : action.payload.y, 
                     _x : action.payload.x,
                     _y : action.payload.y,
                     parent_block_id : action.payload.parent_block_id, 
                     child_block_id : action.payload.child_block_id
                }
            };
        }

        case 'setMagnetPosition' : {
            return {
                ...state,
                magnetPosition : { x : action.payload.x, y : action.payload.y, on : true, id : action.payload.id}
            };
        }

        case 'setZoneSelectBlocks' : {
            return {
                ...state,
                zoneSelectBlocks : { x : action.payload.x, y : action.payload.y }
            };
        }

        case 'setDrag': {
            return {
                ...state,
                pressDown: action.payload.drag
            };
        }

        case 'resetMagnetPosition' : {
            return {
                ...state,
                magnetPosition : { x : 0, y : 0, on : false, id : null}
            };
        }

        case 'resetTmpPath' : {
            return {
                ...state,
                pathTmp : null
            };
        }


        case 'deleteAllSelectedBlock': {
            return {
                ...state,
                blocksSelected : []
            };
        }

        case 'deleteSelectedBlock': {
            const index = state.blocksSelected.findIndex( block => block.id == action.payload.id);
            if(index === -1) {
                return { ...state }
            }

            state.blocksSelected.splice(index, 1)
            return { ...state };
        }

        case 'updateMouse': {
            return {
                ...state,
                mouse : { x : action.payload.x, y : action.payload.y }
            };
        }

        case 'updateMouseAndBlockClicked': {
            return {
                ...state,
                mouse : { x : action.payload.x, y : action.payload.y },
                blockIdClicked : action.payload.id ? action.payload.id : null
            };
        }

        case 'resetState' : {
            return EditorState
        }
        
        default: {
            throw new Error('unhandled action');
        }
    }
}

export default EditorReducer
